import React from "react";
import Form from "react-bootstrap/Form";
import "./VariableTextWidget.scss";

interface IProps {
    title?: string;
    placeholder: string;
    keys: string;
    formValue: string | number;
    invalidState: boolean;
    invalidText?: string;
    width?: number;
    showHelpInfo?: boolean;
    helpText?: string;
    textField?: React.ElementType<any>;
    displayLength?: boolean;
    maxCharAllowed?: number;
    onChange: (e: React.ChangeEvent<any>) => void;
    disabled?: boolean;
    onBlur?: (e: React.FocusEvent<any>) => void;
    id?: string;
    text?: string;
}

function VariableTextWidget(props: IProps) {
    const onSubmitForm = (event: any) => {
        event.preventDefault();
    };

    return (
        <Form className="formcontrolVariableTextWidget" onSubmit={onSubmitForm}>
            <Form.Group className="form-group">
                <Form.Control
                    maxLength={props.maxCharAllowed}
                    as={props.textField ? props.textField : "input"}
                    placeholder={props.placeholder}
                    value={props.formValue}
                    onChange={(e) => !props.disabled && props.onChange(e)}
                    name={props.keys}
                    isInvalid={props.invalidState}
                    width={props.width}
                    disabled={props.disabled}
                    id={props.id || ""}
                    onBlur={(e) => !props.disabled && props.onBlur && props.onBlur(e)}
                    className={props.textField === "textarea" ? "custom-textarea-height" : "custom-control-height"}
                />
            </Form.Group>
        </Form>
    );
}

export default VariableTextWidget;
